import React from 'react';
import queryString from 'query-string';
import { Icon } from '@pella/sash-framework';
import styles from './tags.module.scss';

const PLPFilterTags = (props) => {
	// eslint-disable-next-line react/prop-types -- fix this
	const [loadProductListing, setLoadProductListing] = props.reloadCatalog;
	const tagRemoval = async (question, answer) => {
		const currentQueryParams = new URLSearchParams(queryString.parse(window.location.search)).get('options');
		// let params = new URLSearchParams(props.queryParams);
		let newQueryArray = [];
		if (currentQueryParams !== null) {
			currentQueryParams.split('|').map((qa) => {
				const qaPair = qa.split('=');
				if (qaPair.length !== 2) return null;
				if (qaPair[0] === question) {
					if (qaPair[1].indexOf(',') > -1) {
						// Remove answer from question with comma delimited answers
						newQueryArray.push([question + '=' + qaPair[1].replace(answer, '')]);
					} else if (qaPair[1] === answer) {
						// Remove question and answer if question has single answer
						return null;
					} else {
						// Add back question with still selected answer
						newQueryArray.push([qaPair[0] + '=' + qaPair[1]]);
					}
				} else {
					// Add back other questions
					newQueryArray.push([qaPair[0] + '=' + qaPair[1]]);
				}
			});
		} else {
			// add error messaging
			return null;
		}
		history.replaceState(null, '', window.location.pathname + '?options=' + newQueryArray.join('|').replace(',|', '|'));
		setLoadProductListing(true);
	};

	// eslint-disable-next-line react/prop-types -- fix this
	if (!props.filters?.[0]) return null;

	return (
		// eslint-disable-next-line react/prop-types -- fix this
		!props.pageLoading &&
		// eslint-disable-next-line react/prop-types -- fix this
		props.dynamicPageState &&
		// eslint-disable-next-line react/prop-types -- fix this
		props.filters.map((filter) =>
			filter.answers.filter((answer) => answer.selected === true).length
				? filter.answers.map((tag, index) => {
						// eslint-disable-next-line react/prop-types -- fix this
						if (tag.backend_name === 'Replacement Screens' && props.plpURL === '/shop/windows/parts/screens/') return null; // bandaid?
						// eslint-disable-next-line react/prop-types -- fix this
						if (props?.staticFilters?.length > 0 && !props.staticFilters.find((staticFilter) => staticFilter.backend_name === filter.backend_name)?.answers.find((staticAnswer) => staticAnswer.backend_name === tag.backend_name)?.selected) {
							return tag.selected === true ? (
								<React.Fragment key={index}>
									<input
										id={tag.backend_name}
										type='checkbox'
										className='hidden'
										onClick={() => {
											tagRemoval(filter.backend_name, tag.backend_name);
										}}
									/>
									<label
										className={styles.filterTab}
										id={tag.backend_name}
										htmlFor={tag.backend_name}
									>
										<Icon name='close' /> {tag.display_name}
									</label>
								</React.Fragment>
							) : null;
						}
					})
				: null
		)
	);
};

PLPFilterTags.propTypes = {
	// tile: PropTypes.object,
	// pdpURL: PropTypes.string,
};

export default PLPFilterTags;
